export const MEMBERS_DATA_LOAD = 'members/DATA_LOAD'
export const MEMBERS_DISABLE_USER_INTERACTED_WITH_MAPS =
  'members/DISABLE_USER_INTERACTED_WITH_MAPS'
export const MEMBERS_GET_USER_LOCATION = 'members/GET_USER_LOCATION'
export const MEMBERS_GET_USER_LOCATION_FAILED =
  'members/GET_USER_LOCATION_FAILED'
export const MEMBERS_UPDATE_MAPS_LOCATION = 'members/UPDATE_MAPS_LOCATION'
export const MEMBERS_SHUFFLE_HOME_ITEMS = 'members/SHUFFLE_HOME_ITEMS'
export const MEMBERS_SHUFFLE_TAGS_ITEMS = 'members/SHUFFLE_TAGS_ITEMS'
